import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiOffer, ApiOfferSet, ApiUser, OfferSetsApi } from '@tytapp/api';
import { PageComponent, Redirection } from '@tytapp/common';
import { UserService } from '@tytapp/user';
import { environment } from 'environments/environment';

@Component({
  selector: 'tyt-one-time-contribution',
  templateUrl: './one-time-contribution.component.html',
  styleUrls: ['./one-time-contribution.component.scss']
})
export class OneTimeContributionComponent extends PageComponent {
  private offerSetApi = inject(OfferSetsApi);
  private userService = inject(UserService);
  private redirection = inject(Redirection);
  private route = inject(ActivatedRoute);

  offerSet: ApiOfferSet;

  @Input()
  step = 'pricing';
  offer : ApiOffer;
  offerUUID: string;
  price: number;
  period: string;

  readonly IN_SETTING_DEFAULT_OFFER = 'default:settings_contribution';

  private user: ApiUser;
  private isUpgrade = false;

  offerLoaded = false;

  joinUpgradeLink : string;

  init() {
    this.subscribe(this.userService.userChanged, user => {
      this.user = user;
      this.isUpgrade = this.user 
        && this.user.membership 
        && this.user.membership.active 
        && !this.user.membership.cancelled_at 
        && this.user.membership.gateway_name !== 'free';
      this.updateUpgradeLoginText();
    });

    this.subscribe(this.route.queryParamMap, params => {
      let offerId = params.get('offerId');
      let price = params.get('price');

      if(offerId != null) {
        this.offerUUID = offerId;
      }

      if(price != null) {
        this.price = +price;
      }
    });

    this.loadDefaultOfferSet();
  }

  async loadDefaultOfferSet() {
    this.offerSet = await this.offerSetApi.get(this.IN_SETTING_DEFAULT_OFFER, true).toPromise();
    this.period = 'one_time';
    this.offerLoaded = true;
  }

  get appUrl() {
    return environment.urls.app;
  }
  
  gotoMembership() {
    const url = `${environment.urls.app}/settings/memberships`;
    this.redirection.go(url);
  }

  upgradeJoinButtonText = '';
  upgradeLoginCaptionText = '';

  private updateUpgradeLoginText() {
    if(this.isUpgrade) {
      this.upgradeJoinButtonText = 'Upgrade Now';
      this.upgradeLoginCaptionText = 'Want to donate monthly or annually? Upgrade your membership instead!';
      this.joinUpgradeLink = `/changeMembership`;
    } else {
      this.upgradeJoinButtonText = 'Join Now';
      this.upgradeLoginCaptionText = 'Want to donate monthly or annually? Join now instead!';
      this.joinUpgradeLink = `/join`;
    }
  }

}
